import { useDesktop } from '@revenuewell/front-end-bundle';
import { useEffect } from 'react';
import { isStarted } from '../use-phone-actions/provider';
import { usePhoneActions } from '../use-phone-actions/use-phone-actions';
import { usePhoneLock } from '../use-phone-lock/use-phone-lock';
import useScreenPop from '../use-screen-pop/use-screen-pop';
import usePhone from './use-phone';

export const useWebPhone = () => {
  const {
    deviceControl: { deviceStatus, deviceId },
    webPhoneStatus: { isEnabled },
    refreshKazooDeviceSettings,
    confirmActiveDeviceHasLock,
    lockDevice
  } = usePhone();
  const { deviceLockStatus, deviceLockCredentials } = usePhoneLock();
  const { screenPopEnabled } = useScreenPop();
  const { start, stop, microphoneExists, setRingerEnabled } = usePhoneActions();
  const { isDesktopApplication, isDesktopWidget } = useDesktop();

  useEffect(() => {
    if (isDesktopApplication() && !isDesktopWidget) return;

    const handlePageLeave = () => stop();
    window.addEventListener('unload', handlePageLeave);
    window.addEventListener('pagehide', handlePageLeave);

    return () => {
      stop();
      window.removeEventListener('unload', handlePageLeave);
      window.removeEventListener('pagehide', handlePageLeave);
    };
  }, []);

  useEffect(() => {
    if (!deviceLockCredentials) return;

    if (deviceLockStatus === 'current-client-pending' && !isStarted()) {
      start({
        server: deviceLockCredentials.sipWss,
        auth: {
          username: deviceLockCredentials.sipUserName,
          password: deviceLockCredentials.sipPassword,
          realm: deviceLockCredentials.sipRealm
        }
      });
    }

    if (deviceLockStatus === 'in-use-by-other-client') stop();
  }, [deviceLockStatus, deviceLockCredentials, isStarted]);

  useEffect(() => {
    if (isDesktopApplication() && !isDesktopWidget) return;
    if (!deviceId) return;

    (async () => {
      if (isEnabled) {
        await microphoneExists();
        await lockDevice();
      } else {
        await stop();
      }
    })();

    const interval = setInterval(() => refreshKazooDeviceSettings(deviceId), 60000);
    return () => clearInterval(interval);
  }, [isEnabled, deviceId]);

  useEffect(() => {
    if (isDesktopApplication() && !isDesktopWidget) return;

    let interval: any = null;
    const timeout = isDesktopWidget ? 60 * 1000 : 120 * 1000;

    if (deviceLockStatus === 'in-use-by-other-client') interval = setInterval(() => lockDevice(), timeout);
    if (deviceLockStatus === 'current-client-active')
      interval = setInterval(() => confirmActiveDeviceHasLock(), 100 * 1000);

    return () => clearInterval(interval);
  }, [deviceLockStatus, deviceId]);

  useEffect(() => {
    if (isDesktopApplication() && !isDesktopWidget) return;
    setRingerEnabled(screenPopEnabled);
  }, [deviceStatus]);

  return {};
};
